<template>
  <div :class="[baseCss, isVertical ? 'h-full' : 'w-full', `${position}-0`]" :style="{background}">
    <line-ripple v-if="showRipple && position === 'bottom'" :visible="ripple" bg-color="transparent" :bg-color-lightness="null" :ripple-bg-color="iconColor" :ripple-bg-color-lightness="iconColorLightness" />
    <radio-group :icon-provider="iconProvider" :icon-checked="iconChecked" :icon-blank="iconBlank" :icon-size="iconSize" :name="name" v-model="model" :vertical="isVertical" align="center">
      <radio :icon-color="iconColor" :icon-color-lightness="iconColorLightness" :value="radio" v-for="radio in length" :key="radio" />
    </radio-group>
    <line-ripple height="3px" v-if="showRipple && position === 'top'" :visible="ripple" bg-color="transparent" :bg-color-lightness="null" :ripple-bg-color="iconColor" :ripple-bg-color-lightness="iconColorLightness" />
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'ParallaxControls',
  mixins: [
    methods
  ],
  data () {
    return {
      radios: [],
      model: null,
      length: 0,
      ripple: true,
      name: this.$uuidv4(),
      baseCss: this.componentBaseCss('parallax-controls', ['absolute', 'user-select-none'])
    }
  },
  props: {
    visible: {
      type: Number,
      default: 1
    },
    showRipple: {
      type: Boolean,
      default: true
    },
    background: {
      type: String,
      default: 'rgba(0, 0, 0, .5)'
    },
    iconProvider: {
      type: String,
      default: 'mdi'
    },
    iconChecked: {
      type: String,
      default: 'circle'
    },
    iconBlank: {
      type: String,
      default: 'circle-outline'
    },
    iconSize: {
      type: Number,
      default: 1.5
    },
    iconColor: {
      type: String,
      default: 'white'
    },
    iconColorLightness: {
      type: Number,
      default: null
    },
    position: {
      type: String,
      default: 'top',
      validator: value => {
        return ['top', 'right', 'bottom', 'left'].includes(value)
      }
    }
  },
  computed: {
    isVertical () {
      return !['top', 'bottom'].includes(this.position)
    }
  },
  watch: {
    model () {
      this.ripple = true
      this.getItems()[parseInt(this.model, 10) - 1].scrollIntoView({
        behavior: 'smooth',
        block: 'center', // this.position === 'top' ? 'center' : 'nearest',
        inline: 'nearest'
      })
      this.$parent.$emit('item-slide', parseInt(this.model, 10))
      setTimeout(() => {
        this.ripple = false
      }, 500)
    }
  },
  mounted () {
    this.onMounted()
  },
  destroyed () {
    this.getParent().querySelector('.bcq-parallax-wrapper').style.overflow = ''
  },
  methods: {
    onMounted () {
      this.getParent().querySelector('.bcq-parallax-wrapper').style.overflow = 'hidden'
      this.length = this.getItems().length
      this.model = this.visible
    },
    getItems () {
      return this.getParent().querySelectorAll('.bcq-parallax-item')
    },
    getParent () {
      return this.$parent.$el
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/parallax-controls/parallax-controls.vue